import { Link, useRouterState } from '@tanstack/react-router'
import UserMenu from './UserMenu'
import { shouldHideHeaderForPathname } from '../lib/route-paths'

const navLinks = [
  { to: '/' as const, label: 'Home' },
  { to: '/devices' as const, label: 'Devices' },
  { to: '/rules' as const, label: 'Rules' },
  { to: '/schedules' as const, label: 'Schedules' },
]

export function ClientNav() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })

  const isActive = (path: string) => {
    if (path === '/devices') return pathname === '/devices' || pathname.startsWith('/devices/')
    if (path === '/rules') return pathname === '/rules' || pathname.startsWith('/rules/')
    if (path === '/schedules') return pathname === '/schedules' || pathname.startsWith('/schedules/')
    return pathname === path
  }

  const showHeader = pathname ? !shouldHideHeaderForPathname(pathname) : true
  if (!showHeader) return null

  return (
    <header className="pt-4 pb-3 px-3 sm:pt-5 sm:px-0">
      <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div className="flex justify-center">
          <nav className="w-full sm:w-auto inline-flex items-center justify-start gap-2 bg-white rounded-2xl sm:rounded-full px-4 py-2 shadow-sm border border-gray-100">
            <div className="flex items-center gap-1 shrink-0">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors min-w-[60px] text-center whitespace-nowrap ${
                    isActive(link.to)
                      ? 'bg-brand text-white'
                      : 'text-gray-600 hover:bg-gray-100 bg-transparent transition-colors'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
            <div className="shrink-0">
              <UserMenu />
            </div>
          </nav>
        </div>
      </div>
    </header>
  )
}
